/**
 * SponsorsPage — Tiered sponsor display and become-a-sponsor CTA.
 */
import React from 'react';
import { Link } from 'react-router-dom';
import PageHeader from './PageHeader';
import styles from './SponsorsPage.module.css';

const SPONSORS = {
  Platinum: [
    {
      name: 'Potomac Family Dental',
      logo: '/assets/sponsor/FamilyDentalLogo.png',
      url: 'https://potomacfamilydental.com/',
    },
    {
      name: 'FIRST',
      logo: '/assets/sponsor/FIRST_Logo.png',
      url: 'https://www.firstinspires.org/',
    },
    {
      name: 'Aelio Web Development',
      logo: '/assets/sponsor/FIRST_Logo.png',
      url: 'https://aelio.dev',
    },
  ],
  Gold: [],
  Silver: [],
};

function SponsorsPage() {
  return (
    <div className={`roar-page ${styles.page}`}>
      <PageHeader
        eyebrow="Sponsors"
        title="Partners who make the season possible"
        lead="Robotics is expensive. Our sponsors fund parts, registration, and shop tools — and mentor us along the way."
      />

      <div className={styles.content}>
        {Object.entries(SPONSORS).map(([tier, sponsors]) => (
          <section key={tier} className={styles.tier}>
            <h2 className={styles.tierName}>{tier}</h2>
            {sponsors.length === 0 ? (
              <p className={styles.logoName}>Open — inquire below</p>
            ) : (
              <div className={styles.logos}>
                {sponsors.map((s) => (
                  <a
                    key={s.name}
                    href={s.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={styles.logoLink}
                  >
                    <div className={styles.logoBox}>
                      <img src={s.logo} alt={s.name} className={styles.logoImg} />
                    </div>
                  </a>
                ))}
              </div>
            )}
          </section>
        ))}
      </div>

      <section className={styles.ctaBand}>
        <div className={styles.ctaInner}>
          <div>
            <h2 className={styles.ctaTitle}>Become a sponsor</h2>
            <p className={styles.ctaText}>
              Corporate and individual support keeps our program running. Reach out
              for sponsorship tiers, tax-deductible giving through Fairfax High
              School, or in-kind donations.
            </p>
          </div>
          <Link to="/contact" className={`roar-btn roar-btn-primary ${styles.ctaBtn}`}>
            Contact us
          </Link>
        </div>
      </section>
    </div>
  );
}

export default SponsorsPage;
